import { render, staticRenderFns } from "./PlacementActivity.vue?vue&type=template&id=4ea053f2&scoped=true&"
import script from "./PlacementActivity.vue?vue&type=script&lang=js&"
export * from "./PlacementActivity.vue?vue&type=script&lang=js&"
import style0 from "./PlacementActivity.vue?vue&type=style&index=0&id=4ea053f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea053f2",
  null
  
)

export default component.exports